import PropTypes from 'prop-types'

import { menuTitlePropType } from '../../menu-title/prop-types'
import { userDetailsPropType } from '../../users/prop-types'

import dishIngredientExplanationPropType from './dish-ingredient-explanation-prop-type'
import dishIngredientPropType from './dish-ingredient-prop-type'

const dishPropType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  tier: PropTypes.string,
  description: PropTypes.string,
  ingredients: PropTypes.string,
  styledName: PropTypes.string,
  styledDescription: PropTypes.string,
  styledIngredients: PropTypes.string,
  isPublished: PropTypes.bool,
  isDeleted: PropTypes.bool,
  isFake: PropTypes.bool,
  isLocked: PropTypes.bool,
  isTierOneDone: PropTypes.bool,
  isCurationDone: PropTypes.bool,
  isQaDone: PropTypes.bool,
  isQcDone: PropTypes.bool,
  isEnabled: PropTypes.bool,
  isAiIgnored: PropTypes.bool,
  isManualIgnored: PropTypes.bool,
  lowPrice: PropTypes.number,
  highPrice: PropTypes.number,
  certainty: PropTypes.number,
  dietDescriptors: PropTypes.arrayOf(PropTypes.string),
  allergenDescriptors: PropTypes.arrayOf(PropTypes.string),
  addonDescriptors: PropTypes.arrayOf(PropTypes.string),
  miscDescriptors: PropTypes.arrayOf(PropTypes.string),
  nutritionDescriptors: PropTypes.arrayOf(PropTypes.string),
  mainIngredients: PropTypes.arrayOf(dishIngredientPropType),
  additionalIngredients: PropTypes.arrayOf(dishIngredientPropType),
  choiceIngredients: PropTypes.arrayOf(dishIngredientPropType),
  blacklistedIngredients: PropTypes.arrayOf(dishIngredientPropType),
  ingredientExplanations: PropTypes.arrayOf(dishIngredientExplanationPropType),
  aiSuggestions: PropTypes.object,
  dishType: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    isIgnored: PropTypes.bool,
  }),
  courseType: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  menuTitle: menuTitlePropType,
  diets: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }),
  ),
  allergens: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }),
  ),
  updatedBy: userDetailsPropType,
  updatedAt: PropTypes.string,
  createdBy: userDetailsPropType,
  createdAt: PropTypes.string,
  tierOneDoneAt: PropTypes.string,
  tierOneDoneBy: userDetailsPropType,
  curatedBy: userDetailsPropType,
  curatedAt: PropTypes.string,
  qadBy: userDetailsPropType,
  qcdBy: userDetailsPropType,
  qadAt: PropTypes.string,
  qcdAt: PropTypes.string,
  miscAndChoiceUpdatedAt: PropTypes.string,
  dishTypeUpdatedAt: PropTypes.string,
  courseTypeUpdatedAt: PropTypes.string,
  dietsUpdatedAt: PropTypes.string,
  allergensUpdatedAt: PropTypes.string,
  ingredientsUpdatedAt: PropTypes.string,
  isPublishedUpdatedAt: PropTypes.string,
  lastModifiedByTierOneAt: PropTypes.string,
  lastModifiedByCuratorAt: PropTypes.string,
  lastModifiedByQaAt: PropTypes.string,
  lastModifiedByQcAt: PropTypes.string,
  lastRestSuggestionsAt: PropTypes.string,
  lastPubSubSuggestionsAt: PropTypes.string,
  lastModifiedByTierOne: userDetailsPropType,
  lastModifiedByCurator: userDetailsPropType,
  lastModifiedByQa: userDetailsPropType,
  lastModifiedByQc: userDetailsPropType,
})

export default dishPropType
